import { useIntl } from 'react-intl'
import StructureLabel from 'LuxKit/Label/StructureLabel'
import LineFamilyIcon from 'LuxKit/Icons/line/LineFamilyIcon'

function GreatForFamiliesLabel() {
  const intl = useIntl()

  return (
    <StructureLabel
      variant="standard"
      startIcon={<LineFamilyIcon />}
    >
      {intl.formatMessage({
        id: '7Te8m_PzAwL7hMrjyP1q',
        defaultMessage: 'Great for Families',
      })}
    </StructureLabel>
  )
}

export default GreatForFamiliesLabel
